import About from '../components/About';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-primary-50 pt-20">
      <About />
    </div>
  );
};

export default AboutPage;
